var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4245_19325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8657 8.38575C17.2072 6.94575 14.6249 2.25 8.9999 2.25C3.3749 2.25 0.792653 6.94575 0.134153 8.38575C0.0457571 8.57873 0 8.78849 0 9.00075C0 9.21301 0.0457571 9.42277 0.134153 9.61575C0.792653 11.0542 3.3749 15.75 8.9999 15.75C14.6249 15.75 17.2072 11.0542 17.8657 9.61425C17.9539 9.42149 17.9995 9.21199 17.9995 9C17.9995 8.78801 17.9539 8.57851 17.8657 8.38575ZM8.9999 14.25C4.26965 14.25 2.0624 10.2255 1.4999 9.00825C2.0624 7.7745 4.26965 3.75 8.9999 3.75C13.7189 3.75 15.9269 7.75725 16.4999 9C15.9269 10.2428 13.7189 14.25 8.9999 14.25Z",
    fill: "#494F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.25024C8.25832 5.25024 7.5333 5.47018 6.91661 5.88223C6.29993 6.29429 5.81928 6.87996 5.53545 7.56518C5.25162 8.2504 5.17736 9.0044 5.32206 9.73183C5.46675 10.4593 5.8239 11.1274 6.34835 11.6519C6.8728 12.1763 7.54098 12.5335 8.26841 12.6782C8.99584 12.8229 9.74984 12.7486 10.4351 12.4648C11.1203 12.181 11.706 11.7003 12.118 11.0836C12.5301 10.4669 12.75 9.74192 12.75 9.00024C12.7488 8.00605 12.3533 7.05291 11.6503 6.34991C10.9473 5.64691 9.9942 5.25144 9 5.25024ZM9 11.2502C8.55499 11.2502 8.11998 11.1183 7.74997 10.8711C7.37996 10.6238 7.09157 10.2724 6.92127 9.86128C6.75098 9.45015 6.70642 8.99775 6.79323 8.56129C6.88005 8.12483 7.09434 7.72392 7.40901 7.40925C7.72368 7.09459 8.12459 6.88029 8.56105 6.79348C8.99751 6.70666 9.44991 6.75122 9.86104 6.92151C10.2722 7.09181 10.6236 7.3802 10.8708 7.75021C11.118 8.12022 11.25 8.55524 11.25 9.00024C11.25 9.59698 11.0129 10.1693 10.591 10.5912C10.169 11.0132 9.59674 11.2502 9 11.2502Z",
    fill: "#494F66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4245_19325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesIcon);
export default __webpack_public_path__ + "static/media/eyes-icon.dd3d3ee3c7e47ccca30af261ba96de4a.svg";
export { ForwardRef as ReactComponent };